import { logger } from '@modules/logger';
import type { CardFieldAction } from '@reducers/card-reducers';
import { createContext } from 'react';
import type { CardFields } from 'types';

const initialContext: cardContextValues = {
  allFieldTypesLocked: false,
  canLock: false,
  cardColor: undefined,
  cardFields: { firstName: '', linkedAttributes: [], fieldOrder: [] },
  cardFieldsDispatch: () => logger.warn('cardFieldsDispatch not provided for cardContext'),
  saveChanges: () => logger.warn('saveChanges not provided for cardContext'),
  rollbackChanges: () => logger.warn('rollbackChanges not provided for cardContext'),
  queueActionOnSave: () => logger.warn('queueActionOnSave not provided for cardContext'),
  lockedFields: [],
  toggleFieldLock: () => logger.warn('toggleFieldLock not provided for cardContext'),
  lockedFieldTypes: [],
  toggleFieldTypeLock: () => logger.warn('toggleFieldTypeLock not provided for cardContext'),
  toggleLockAllFieldTypes: () => logger.warn('toggleLockAllFieldTypes not provided for cardContext'),
  colorLocked: false,
  toggleColorLock: () => logger.warn('toggleColorLock not provided for cardContext'),
  qrCodeLocked: false,
  toggleQRCodeLock: () => logger.warn('toggleQRCodeLock not provided for cardContext'),
  cardId: '',
  layoutImagesLocked: false,
  orgId: '',
  onFieldDelete: undefined,
  toggleLayoutImagesLocked: () => console.warn('toggleLayoutImagesLocked not provided for cardContext'),
  userId: '',
};

export interface cardContextValues {
  allFieldTypesLocked: boolean;
  canLock: boolean;
  cardColor?: string;
  cardFields: CardFields;
  cardFieldsDispatch: (action: CardFieldAction) => void;
  cardId: string;
  colorLocked: boolean;
  layoutImagesLocked: boolean;
  lockedFields: string[];
  lockedFieldTypes: string[];
  orgId?: string;
  qrCodeLocked: boolean;
  queueActionOnSave: (callback: () => void) => void;
  rollbackChanges: () => void;
  saveChanges: (immediate?: boolean) => void;
  toggleColorLock: () => void;
  toggleFieldLock: (id: string, toggleState?: boolean) => void;
  toggleFieldTypeLock: (id: string, toggleState?: boolean) => void;
  toggleLayoutImagesLocked: () => void;
  toggleLockAllFieldTypes: () => void;
  toggleQRCodeLock: () => void;
  userId: string;
  /**
   * This is just for extra stuff that should happen after a field is deleted,
   * as fields can be deleted directly using the card reducer.
   */
  onFieldDelete?: (id: string) => void;
  /**
   * This is to allow for a completely static card with no hover/interactive changes
   */
  interactive?: boolean;
}

const cardContext = createContext<cardContextValues>(initialContext);

export { cardContext };
